import { render } from "./NaturezaSection.vue?vue&type=template&id=81ec6618&scoped=true&lang=pug"
import script from "./NaturezaSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NaturezaSection.vue?vue&type=script&setup=true&lang=js"

import "./NaturezaSection.vue?vue&type=style&index=0&id=81ec6618&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81ec6618"]])

export default __exports__